import { render, staticRenderFns } from "./Faqp.vue?vue&type=template&id=36296e98&"
import script from "./Faqp.vue?vue&type=script&lang=js&"
export * from "./Faqp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports